/**
 * Converts an enum string (e.g., 'FIXED', 'STEP_UP') to a human-readable label (e.g., 'Fixed', 'Step Up').
 * @param enumValue - The enum string to convert.
 * @returns The formatted label.
 */
export function enumToLabel(enumValue: string): string {
	if (!enumValue) return '';
	return enumValue
		.toLowerCase()
		.split('_')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
}
